// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Eq-z","breadcrumbForward":"Fq-z","breadcrumbBack":"Gq-z","selected":"Hq-z"};